import React, { useEffect, useState } from 'react';
import "./Nav.css";

function Nav() {
  const [show,handleShow]=useState(false);
  useEffect(()=>{
    window.addEventListener("scroll", ()=> {
      if(window.scrollY>100){
        handleShow(true);
      } else handleShow(false);
    });
    return ()=>{
      window.removeEventListener("scroll",null);
    };
  },[]);
  return (
    <div className={`nav ${show && "nav__black"}`}>
      <img 
      className="nav__logo"
      src="https://netflix-clone-ebon-nu.vercel.app/f4070143e1f521da82a119eb78b434d0.png"
        alt="NETFLIX LOGO"

        />
        <img 
        className="nav__avatar"
        src="https://upload.wikimedia.org/wikipedia/commons/0/0b/Netflix-avatar.png?20201013161117"
        alt="Netflix logo"/>
    </div>
  )
}

export default Nav